const EARLY_RENEWAL_FIRST_MONTH = 9

const getFamilyPayingProductYear = (today: Date = new Date()): number =>
  today.getMonth() >= EARLY_RENEWAL_FIRST_MONTH
    ? today.getFullYear() + 1
    : today.getFullYear()

export default getFamilyPayingProductYear
